
























import { Vue, Component, Prop } from "vue-property-decorator";
import { ISegmentTypes } from "@/data/enums/segments";
import { IContractProduct } from "@/models/contracts";
import { IAccount } from "@/models/accounts";

@Component({
  components: {
    "products-table": () =>
      import("@/components/app/global/contractProducts/productsTable.vue")
  }
})
export default class SelectClientProductModal extends Vue {
  // Props

  @Prop({ required: true })
  public accountId!: IAccount["id"];

  // Data

  public segmentType: ISegmentTypes = ISegmentTypes.CONTRACTS_PRODUCTS;
  public guardFunctionalities = ["list_client_contracts_products"];

  // Methods

  public selectProduct(contractProduct: IContractProduct) {
    this.$emit("success", contractProduct);
    this.$emit("close");
  }
}
